import { Injectable } from '@angular/core';
import { FieldType } from '@sla-ng/ui-material';
import { IArticleLayout } from '../../models/layout/article-layout.model';
import { IArticleRevenueAddDialogLayout } from '../../models/layout/article-revenue-add-dialog-layout.model';
import { IArticleRevenueDialogLayout } from '../../models/layout/article-revenue-dialog-layout.model';
import { SharedDataFacade } from '../facades/master-data/shared-data.facade';

@Injectable({
    providedIn: 'root',
})
export class ArticleLayoutService {

    constructor(protected mySharedDataFacade: SharedDataFacade) {
    }

    public getArticleLayout(): IArticleLayout {
        return {
            columns: [ 'name', 'articleNr', 'baseMeasureUnitId', 'actions' ],
        };
    }

    public getArticleRevenueDialogLayout(): IArticleRevenueDialogLayout {
        return {
            filterFields: [
                {
                    field: 'costAccountingType',
                    label: 'app.model.article-revenue.costAccountingType.label',
                    type: FieldType.select,
                    withClearButton: true,
                    selectData: {
                        displaySearch: true,
                        labelKeys: [ 'name' ],
                        valueKey: 'id',
                        options: this.mySharedDataFacade.fetchCostAccountingTypes(),
                    },
                },
                {
                    field: 'validity',
                    withClearButton: true,
                    label: 'app.model.article-revenue.validity.label',
                    type: FieldType.daterange,
                },
            ],
            columns: [ 'validFrom', 'validTo', 'costAccountingType', 'revenueCt', 'delete' ],
        };
    }

    public getArticleRevenueAddDialogLayout(): IArticleRevenueAddDialogLayout {
        return {
            fields: [
                {
                    field: 'costAccountingTypeId',
                    label: 'app.model.article-revenue.costAccountingType.label',
                    type: FieldType.select,
                    selectData: {
                        displaySearch: true,
                        labelKeys: [ 'name' ],
                        valueKey: 'id',
                        options: this.mySharedDataFacade.fetchCostAccountingTypes(),
                    },
                },
                {
                    field: 'validity',
                    label: 'app.model.article-revenue.validity.label',
                    type: FieldType.daterange,
                },
                {
                    field: 'revenueEuro',
                    label: 'app.model.article-revenue.revenue.label',
                    type: FieldType.decimal,
                },
            ]
        };
    }

}
